module.exports = __webpack_public_path__ + "img/expense_infographic.7e6f6c3d.svg";